import httpClient from "http-client/http-client";

/**
 * Fetches the combined vendor analytics overview (summary + trends).
 * @param {{ period?: string, community_id?: string }} [opts]
 * @returns {Promise<{ data: object|null, errors: Array }>}
 */
export async function getVendorOverview({ period, community_id } = {}) {
  const body = {};
  if (period) body.period = period;
  if (community_id) body.community_id = community_id;

  return httpClient.post({
    url: "/v1/community-portal/analytics/vendor-overview",
    body,
  });
}
